var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "u-extra-small-margin--bottom" }, [
      _c("strong", [_vm._v("Ampelsysteme:")]),
      _vm._v(" "),
      _c("span", { staticClass: "c-ranking c-ranking--none" }),
      _vm._v(" (keine Bewertung),\n    "),
      _c("span", { staticClass: "c-ranking c-ranking--red" }),
      _vm._v(" (Im Notfall),\n    "),
      _c("span", { staticClass: "c-ranking c-ranking--yellow" }),
      _vm._v(" (Akzeptabel),\n    "),
      _c("span", { staticClass: "c-ranking c-ranking--green" }),
      _vm._v(" (Bevorzugt)\n"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }